import { buildWaitlistFunnelParams, type WaitlistFormLocation } from '@/wabunka-src/common/utils/googleAnalytics/common/waitlistFunnel';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/**
 * 発火タイミング：ウェイトリストの登録フォームが開いた時（開き直すたびに送る）
 */
export const sendGAWabunkaWaitlistFormViewEvent = (experienceSlug: string, location: WaitlistFormLocation) => {
  sendWabunkaGAEvent('waitlist_form_view', buildWaitlistFunnelParams(experienceSlug, location));
};
